import { ArrowRightOutlined, CompassOutlined } from "@ant-design/icons";

export function HomePage() {
  return (
    <main className="tools-home">
      <header className="tools-home__header">
        <a className="tools-home__brand" href="/" aria-label="个人工具集首页">
          <span className="tools-home__brand-mark" aria-hidden>工</span>
          <span>个人工具集</span>
        </a>
        <span className="tools-home__header-note">实用工具，随时可用</span>
      </header>

      <section className="tools-home__intro" aria-labelledby="tools-home-title">
        <p className="tools-home__eyebrow">个人在线工具</p>
        <h1 id="tools-home-title">个人工具集</h1>
        <p>收集并整理日常使用的简单工具，方便在电脑和手机上快速访问。</p>
      </section>

      <section className="tools-home__catalog" aria-labelledby="tools-catalog-title">
        <div className="tools-home__catalog-heading">
          <h2 id="tools-catalog-title">工具列表</h2>
          <span>持续整理中</span>
        </div>

        <article className="tool-entry">
          <div className="tool-entry__icon" aria-hidden><CompassOutlined /></div>
          <div className="tool-entry__content">
            <p className="tool-entry__type">气象工具</p>
            <h3>台风路径工具</h3>
            <p>查看台风路径、预测位置与城市天气影响。</p>
          </div>
          <a className="tool-entry__action" href="/typhoon">
            打开台风路径工具
            <ArrowRightOutlined aria-hidden />
          </a>
        </article>
      </section>

      <footer className="tools-home__footer">
        <span>个人工具集</span>
        <span>提供简单、便捷的在线工具</span>
      </footer>
    </main>
  );
}
